import axios from 'axios';

import { url } from '../config';

// Redux Actions
import { SET_OPTIONS_START, SET_OPTIONS } from '../actions/index.jsx';

// Axios Request
export const fetchOptions = () => {
    return function (dispatch) {
        dispatch({ type: SET_OPTIONS_START });
        axios.get(`${url}/wp-json/acf/v2/options/`).then((response) => {
            dispatch({
                type: SET_OPTIONS,
                payload: response.data,
            });
        });
    };
};



// WEBPACK FOOTER //
// ./src/requests/options_request.js